import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Sentry from "@sentry/react";
import { Link } from 'react-router-dom';
import Pusher from 'pusher-js/with-encryption';

import { AbilityProvider } from '../../_contexts/AbilitiesContext';
import ability from '../../_helpers/ability';

import NavBar from '../../_components/NavBar'
import { PusherProvider } from '../../_contexts/PusherContext';

import './styles.scss';
import { clientActions } from '../../_actions/client.actions';
import { userService } from '../../_services/user.service';
import { authenticationActions } from '../../_actions/authentication.actions';

const pusherClient = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  authEndpoint: process.env.REACT_APP_PUSHER_AUTH,
  wsHost: process.env.REACT_APP_PUSHER_HOST,
  wsPort: process.env.REACT_APP_PUSHER_PORT,
  wssPort: process.env.REACT_APP_PUSHER_PORT,
  encryptionMasterKeyBase64: process.env.REACT_APP_PUSHER_ENCRYPT_KEY,
  forceTLS: true,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  auth: { headers: { Authorization: null }},
  disabledTransports: ['sockjs', 'xhr_polling', 'xhr_streaming'],
})

class App extends Component {
  componentDidMount() {
    Sentry.setUser({ id: this.props.userId });

    pusherClient.config.auth.headers.Authorization = `Bearer ${this.props.token}`

    this.providerChannel = pusherClient.subscribe(`presence-provider.${this.props.clientId}`);

    this.providerChannel
      .bind('pusher:subscription_error', data =>  {})
      .bind('pusher:subscription_succeeded', data =>  {
        this.props.dispatch(clientActions.setUsersOnline(this.props.userId, data.members));
      })
      .bind('pusher:member_added', data => {
        this.props.dispatch(clientActions.addUserOnline({...data.info, typing: false}))
      })
      .bind('pusher:member_removed', data => {
        this.props.dispatch(clientActions.removeUserOnline(data.id));
      })
      .bind('roleUpdated', data => {
        userService.me(this.props.token)
          .then(userData => {
            this.props.dispatch(authenticationActions.setPermissions(userData.permissions))

            // this.props.history.push('/dashboard')
          })
      })
  }

  componentWillUnmount() {
    if (this.providerChannel) {
      this.providerChannel.unbind();

      pusherClient.unsubscribe(`presence-provider.${this.props.clientId}`)
    }
  }

  render() {
    return <AbilityProvider value={ability}> 
      <PusherProvider value={ pusherClient }>
        <NavBar />
                      
        { this.props.children }

        <footer className="footer">
          <div className="container my-auto">
            <div className="text-muted">
              <div className="row">
                <div className="col offset-5 d-flex justify-content-between">
                  <div className='my-auto'>
                    AxS Health <small>v{process.env.REACT_APP_API_VERSION} (Build {process.env.REACT_APP_BUILD})</small>
                  </div>
                  <div>
                    <b>Help</b>
                    <ul className='m-0 pl-3'>
                      <li className='p-0'>
                        <Link to='/tutorials' className='text-muted'>How-To Videos</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </PusherProvider>
    </AbilityProvider>
  }
}

const mapStateToProps = state => {
  return {
    clientId: state.client.id,
    userId: state.user.currentUser.UserId,
    token: state.authentication.token
  }
}

export default connect(mapStateToProps)(App);